import { Component, Inject } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IFormDelegate, IFormOptions, validateNoEmptyField } from '@modeso/aumico-lib-core-fe';
import { UntilDestroy } from '@ngneat/until-destroy';
import { IGroupFormDialogData } from '../../../interfaces/group-form-dialog-data.interface';
import { IGroupFormDialogResult } from '../../../interfaces/group-form-dialog-result.interface';

@UntilDestroy()
@Component({
    selector: 'templates-group-form',
    templateUrl: './group-form.dialog.html',
    styleUrls: ['./group-form.dialog.scss'],
})
export class GroupFormDialogComponent {
    public options: IFormOptions;
    public formDelegate: IFormDelegate;
    public nameAlreadyExists = false;
    public formGroup: UntypedFormGroup | undefined;

    constructor(
        public dialogRef: MatDialogRef<GroupFormDialogComponent, IGroupFormDialogResult | undefined>,

        @Inject(MAT_DIALOG_DATA) public data: IGroupFormDialogData,
    ) {
        this.initializeForm();
    }

    private initializeForm(): void {
        this.formGroup = new UntypedFormGroup({
            name: new UntypedFormControl(null, [
                (control: AbstractControl): ValidationErrors | null => Validators.required(control),
                validateNoEmptyField(),
            ]),
            totalName: new UntypedFormControl(null, [
                (control: AbstractControl): ValidationErrors | null => Validators.required(control),
                validateNoEmptyField(),
            ]),
            financialLineItems: new UntypedFormControl(null),
        });
    }

    public onSaveClicked(): void {
        if (this.formGroup == null || this.formGroup.invalid) {
            this.formGroup?.markAllAsTouched();
            return;
        }

        const name = this.formGroup.get('name')?.value as string;
        const totalName = this.formGroup.get('totalName')?.value as string;
        const groupName = name.trim();

        this.nameAlreadyExists =
            this.data.existingGroupsNames.find((existingGroupName) => existingGroupName === groupName) != null;

        if (this.nameAlreadyExists) {
            this.formGroup.get('name')?.setErrors({ nameAlreadyExists: true });
        } else {
            this.dialogRef.close({
                name: groupName,
                totalName: totalName.trim(),
                financialLineItems: this.formGroup.get('financialLineItems')?.value,
            });
        }
    }

    public closeDialog(): void {
        this.dialogRef.close();
    }
}
